import React, { forwardRef } from 'react'
import styled, { css } from 'styled-components'
import { colors } from '@styles/vars'
import { autofill, modifier, placeholder } from '@styles/mixins'

const TextArea = ({ label, ...attributes }: TextAreaProps, ref: any) => {
    return (
        <Wrapper>
            {label && <label htmlFor={attributes.id}>{label}</label>}
            <textarea {...attributes}></textarea>
        </Wrapper>
    )
}

export default forwardRef(TextArea)

/* STYLES */
const Wrapper = styled.div`
    label {
        display: block;
        font-weight: bold;
        margin-bottom: 10px;
        cursor: pointer;
    }

    textarea {
        width: 100%;
        height: 150px;
        color: ${colors.black};
        transition: .2s ease-out;
        padding: 15px;
        border-radius: 5px;
        border: 0;
        font-weight: 600;
        background: ${colors.white};
        border: 1px solid ${colors.border};
        transition: .2s ease-out;
        resize: none;
        line-height: 150%;

        &:focus {
            outline: none;
        }

        ${autofill(css`
            -webkit-box-shadow: inset 0 0 0 50px ${colors.accentBackground} !important;
        `)}

        ${modifier("background:primary", css`
            background: ${colors.elementBackground};

            &:focus {
                background: ${colors.elementBackgroundFocused};
            }

            ${autofill(css`
                -webkit-box-shadow: inset 0 0 0 50px ${colors.elementBackgroundFocused} !important;
            `)}
        `)}

        ${placeholder(css`
            opacity: .6;
            color: ${colors.darkGrey};
            font-weight: 400;
        `)}

        ${modifier('icon', css`
            padding-left: 50px;
        `)}

        ${modifier("format:ch", css`
            box-sizing: content-box;
            padding: 10px;
            width: 1ch;
            max-width: 6ch;
            height: auto;

            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }

            -moz-appearance: textfield;
        `)}
    }
`

// TYPES
type TextAreaProps = React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> & { label?: string }